<template>
  <custom-popover
    class="format-popover"
    ref="popover"
    :style="{ left: popoverPosition.x + 'px', top: popoverPosition.y + 8 + 'px' }"
    @close="$emit('close')"
    :backdrop="true"
  >
    <!-- <div class="format-selector" :style="{ height: popoverMeasurements.height + 'px' }"> -->
    <div class="format-selector">
      <variable-format-selector
        v-if="selectedVariable && variable"
        class="variable-format"
        :variable="variable"
        :format="selectedVariable.format"
        @format-changed="onFormatChanged"
      />
    </div>
    <div class="actions">
      <button @click="$emit('close')">
        {{ $t("editor-expression.cancel") }}
      </button>
      <button @click="applyFormat">
        {{ $t("editor-expression.save") }}
      </button>
    </div>
  </custom-popover>
</template>

<script>
import VariableHelpers from "@/assets/js/variableHelpers.js";
import CustomPopover from "@/components/CustomPopover";
import VariableFormatSelector from "@/components/VariableFormatSelector";
export default {
  components: {
    VariableFormatSelector,
    CustomPopover
  },
  props: {
    pos: Object,
    // selectedVariable: Object,
    expression: String
  },
  data() {
    return {
      selectedVariable: null,
      hasChanges: false,
      popoverPosition: {},
      popoverMeasurements: {},
      format: null
    };
  },
  methods: {
    checkElementPosition() {
      const bounds = this.$refs.popover.$el.getBoundingClientRect();
      this.popoverHeight = bounds.height;
      this.popoverPosition = this.pos;
      // Ensure that the popover does not open below the screens height
      const windowHeight = window.innerHeight;

      if (this.popoverHeight + this.pos.y > windowHeight) {
        this.$set(this.popoverPosition, "y", this.popoverPosition.y - this.popoverHeight);
      }
    },

    selectVariable() {
      this.$emit("select-variable", this.selectedVariable, this.variable);
    },

    onFormatChanged(format) {
      this.format = format;
    },
    applyFormat() {
      this.$emit("update-variable-format", this.format);
      this.$emit("close");
    }
  },
  computed: {
    variable() {
      // return the actual variable, not the instance
      if (this.selectedVariable) return this.$store.getters.combinedVariables[this.selectedVariable.name];
      else return null;
    },
    variables() {
      return this.$store.getters.combinedVariables;
    }
  },
  mounted() {
    this.selectedVariable = {
      name: VariableHelpers.removeFormatting(this.expression),
      format: VariableHelpers.getFormatting(this.expression)
    };
    this.$nextTick(() => {
      this.checkElementPosition();
    });
  }
};
</script>

<style lang="less">
.format-popover {
  position: fixed;
  z-index: 102;
  .format-selector {
    border-radius: 10px 10px 0 0;
    padding-bottom: 12px;
    padding-top: 12px;
    background: #f1f1f1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .actions {
    display: flex;
    justify-content: center;
    border-top: 1px solid #3d464a5d;
    border-radius: 0 0 10px 10px;
    background: #fff;
    button {
      transition: 0.1s;
      flex: 1 1 auto;
      border: none;
      background: none;
      padding: 8px 20px;
      color: var(--charcoal);
      &:disabled,
      &:hover {
        opacity: 0.75;
      }
      &:first-of-type {
        border-right: 1px solid #3d464a5d;
      }
    }
  }
}
#aiPopover input.form-control {
  color: #000;
}
</style>
